var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_88_226)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 49,
    height: 49,
    fill: "#FFB444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 51,
    height: 51,
    stroke: "black",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4948 15.4946C20.958 15.4946 16.4896 19.9631 16.4896 25.5C16.4896 31.0369 20.958 35.5054 26.4948 35.5054C32.0315 35.5054 36.5 31.0369 36.5 25.5C36.5 19.9631 32.0315 15.4946 26.4948 15.4946ZM26.4948 32.0028C22.9142 32.0028 19.9921 29.0807 19.9921 25.5C19.9921 21.9193 22.9142 18.9972 26.4948 18.9972C30.0754 18.9972 32.9974 21.9193 32.9974 25.5C32.9974 29.0807 30.0754 32.0028 26.4948 32.0028ZM36.9097 12.753C35.617 12.753 34.5731 13.797 34.5731 15.0897C34.5731 16.3825 35.617 17.4264 36.9097 17.4264C38.2025 17.4264 39.2464 16.3873 39.2464 15.0897C39.2468 14.7827 39.1866 14.4787 39.0693 14.195C38.952 13.9114 38.7799 13.6536 38.5629 13.4366C38.3458 13.2195 38.0881 13.0474 37.8044 12.9301C37.5207 12.8128 37.2167 12.7526 36.9097 12.753ZM45.9978 25.5C45.9978 22.8072 46.0222 20.1388 45.871 17.4508C45.7198 14.3287 45.0075 11.5578 42.7245 9.27479C40.4367 6.98687 37.6707 6.27951 34.5487 6.12829C31.8559 5.97706 29.1875 6.00145 26.4996 6.00145C23.8069 6.00145 21.1385 5.97706 18.4506 6.12829C15.3285 6.27951 12.5577 6.99174 10.2747 9.27479C7.98685 11.5627 7.27951 14.3287 7.12828 17.4508C6.97706 20.1436 7.00145 22.8121 7.00145 25.5C7.00145 28.1879 6.97706 30.8612 7.12828 33.5492C7.27951 36.6713 7.99173 39.4422 10.2747 41.7252C12.5626 44.0131 15.3285 44.7205 18.4506 44.8717C21.1434 45.0229 23.8117 44.9986 26.4996 44.9986C29.1924 44.9986 31.8608 45.0229 34.5487 44.8717C37.6707 44.7205 40.4415 44.0083 42.7245 41.7252C45.0124 39.4373 45.7198 36.6713 45.871 33.5492C46.0271 30.8612 45.9978 28.1928 45.9978 25.5ZM41.705 37.003C41.3489 37.8909 40.9196 38.5543 40.2318 39.2373C39.544 39.9251 38.8854 40.3544 37.9976 40.7105C35.4316 41.7301 29.3388 41.5008 26.4948 41.5008C23.6508 41.5008 17.553 41.7301 14.9871 40.7154C14.0992 40.3593 13.4358 39.93 12.7529 39.2422C12.065 38.5543 11.6357 37.8958 11.2796 37.0079C10.265 34.437 10.4942 28.344 10.4942 25.5C10.4942 22.656 10.265 16.5581 11.2796 13.9921C11.6357 13.1042 12.065 12.4408 12.7529 11.7578C13.4407 11.0749 14.0992 10.6407 14.9871 10.2846C17.553 9.26991 23.6508 9.49919 26.4948 9.49919C29.3388 9.49919 35.4365 9.26991 38.0024 10.2846C38.8903 10.6407 39.5537 11.07 40.2367 11.7578C40.9245 12.4457 41.3538 13.1042 41.7099 13.9921C42.7245 16.5581 42.4953 22.656 42.4953 25.5C42.4953 28.344 42.7245 34.437 41.705 37.003Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_88_226",
    x: 0,
    y: 0,
    width: 57,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88_226"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_88_226",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b90879544bba006a2ae2c63e6a3b7d9f.svg";
export { ForwardRef as ReactComponent };